<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { Order } from "@/services/westore/entities";
import moment from "moment";
import { Download } from "@/mixins/download";
import { channels } from "@/mixins/channels";
import Modal from "../../../components/modal.vue";
import myMixin from "../../../plugins/myMixin";
import WsTable from "../../../components/westoreTable/ws-table.vue";
import SkeletonLoader from "../../../components/skeletons/skeleton-loader.vue";
import { mapGetters } from "vuex";
export default {
  mixins: [Download, channels, myMixin],
  page: {
    title: "Orders List",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Modal,
    WsTable,
    SkeletonLoader,
  },
  data() {
    return {
      title: this.$t("Orders List"),
      modalTitle: this.$t("Orders"),
      modalNote: this.$t(
        "We support up to 500 orders per upload. - File type must be xslx"
      ),
      errors: [],
      filter: {
        date_from: null,
        date_to: null,
        status: null,
      },
      orderSearch: {
        searchBy: null,
        searchId: null,
      },
      sortBy: "id",
      sortDesc: false,
      currentPage: 1,
      perPage: 20,
      totalItems: 0,
      items: [],
      paginateStart: 1,
      fields: [
        {
          key: "order_number",
          label: this.$t("Order ID"),
          sortable: true,
        },
        {
          key: "reference_number",
          label: this.$t("Reference ID"),
          sortable: true,
        },
        {
          key: "recipient.name",
          label: this.$t("CUSTOMER NAME"),
          sortable: true,
        },
        // {
        //   key: "recipient.email",
        //   label: this.$t("Email"),
        //   sortable: true,
        // },
        {
          key: "city.country.name",
          label: this.$t("Country"),
          sortable: true,
        },
        {
          key: "city.name",
          label: this.$t("City"),
          sortable: true,
        },
        {
          key: "created_at",
          label: this.$t("CREATED AT"),
          sortable: true,
        },
        // {
        //   key: "delivery-speed",
        //   label: this.$t("Delivery Speed"),
        //   sortable: false,
        // },
        {
          key: "status",
          label: this.$t("Order Status"),
          sortable: true,
        },
        {
          key: "total",
          label: this.$t("Total Price"),
          sortable: true,
        },
        {
          key: "attachments",
          label: this.$t("Attachments"),
          sortable: false,
        },
      ],
      showContentLoader: true,
      openImportModal: false,
    };
  },
  computed: {
    ...mapGetters({
      services: ["auth/services"],
    }),
  },
  mounted() {
    this.fetchData();
  },
  watch: {
    currentPage: {
      handler: function () {
        this.fetchData();
      },
    },
  },
  methods: {
    async fetchData() {
      this.showContentLoader = true;

      const requestParams = {
        ...this.filter,
        page: this.currentPage,
        per_page: this.perPage,
      };

      let resp = await Order.getAll(requestParams);

      this.items = resp.data;
      this.totalItems = resp.meta.total;
      this.showContentLoader = false;
    },
    applyFilter() {
      this.logGAEvent("order", "search", "click on search button in order tab");
      this.currentPage = 1;

      if (this.orderSearch.searchBy && this.orderSearch.searchId) {
        delete this.filter.reference_number;
        delete this.filter.order_number;
        this.filter[this.orderSearch.searchBy] = this.orderSearch.searchId;
      }

      this.fetchData();
    },
    resetFilter() {
      this.currentPage = 1;
      this.filter = {
        date_from: null,
        date_to: null,
        status: null,
      };
      this.orderSearch = {
        searchBy: null,
        searchId: null,
      };
      this.fetchData();
    },
    convertDate: function (timestampValue) {
      return moment.unix(timestampValue).format("DD/MM/YYYY");
    },
    async exportSheet(extension) {
      this.logGAEvent(
        "order",
        "export",
        "click on export button in orders tab"
      );
      const data = await Order.blobResponse().export(extension, this.filter);

      const type = Order.getHeader("content-type");
      const filename = `order_${new Date().getTime()}.${extension}`;
      this.download(data, type, filename);
    },
    async handleChangeDeliverySpeed(order) {
      try {
        await Order.update(order);
        this.$toast.success(
          "Your order delivery speed has been updated successfully"
        );
      } catch (error) {
        this.$toast.error("Something went wrong,please try again");
      } finally {
        console.log("finally");
      }
    },
    closeModal() {
      this.openImportModal = false;
    },
    handleCreateOrder() {
      this.logGAEvent(
        "order",
        "create new order",
        "click on create new order button from orders tab"
      );
      this.$router.push("/orders/create");
    },
    onRowClicked(item) {
      this.$router.push({
        name: "order-details",
        params: { id: item.id },
      });
    },
    async downloadFile(id, path) {
      console.log("id", id);
      console.log("path", path);

      let extension = "pdf";
      const data = await Order.blobResponse().getFile(id, path);

      const type = Order.getHeader("content-type");
      const filename = `order_${path}_${new Date().getTime()}.${extension}`;
      this.download(data, type, filename);
    },
    async uploadSuccess(file) {
      let data = new FormData();
      data.append("file", file);
      try {
        let { data: resData } = await Order.uploadOrders(data);
        console.log(resData);
        if (resData.status === "success") {
          this.closeModal();
          this.$toast.success("Your order  has been uploaded successfully");
          this.fetchData();
        } else if (resData.status === "fail") {
          this.errors = resData.errors;
          this.$toast.error("There are mismatches in your file,");
        }
      } catch (error) {
        console.log("false catch");
        this.$toast.error("Something went wrong,please try again");
      } finally {
        //  this.$refs.myVueDropzone.removeAllFiles();
      }
    },
    async downloadTemplate() {
      let data = await Order.blobResponse().getTemplate();
      const type = Order.getHeader("content-type");
      const filename = `order_${new Date().getTime()}.xlsx`;
      this.download(data, type, filename);
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title">
      <div v-if="Object.values(services).every((el) => el === false) || services.storage == true">
        <b-button
          type="submit"
          variant="warning"
          class="btn-block mr-2"
          size="md"
          @click="$router.push({ name: 'order-return-create' })"
          >{{ $t("New Return") }}</b-button
        >
        <b-button
          type="submit"
          variant="primary"
          class="btn-block mr-2"
          size="md"
          @click="handleCreateOrder"
          ><i :class="isRtl ? 'fa fa-plus ml-3' : 'fa fa-plus mr-3'"></i
          >{{ $t("Create new") }}</b-button
        >
      </div>
      <div v-else>
        <b-button
          v-if="services.domestic"
          type="submit"
          variant="info"
          class="btn-block mr-2"
          size="md"
          @click="handleCreateOrder"
          ><i class="fa fa-plus mr-3"></i>New Domestic Order</b-button
        >

        <b-button
          v-if="services.international"
          type="submit"
          variant="primary"
          class="btn-block"
          size="md"
          @click="handleCreateOrder"
          ><i class="fa fa-plus mr-3"></i>New International Order</b-button
        >
      </div>
    </PageHeader>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <!-- Table -->
            <div class="row mb-5">
              <div class="col-xl-2 col-sm-6 pt-0">
                <div class="form-group mb-0">
                  <label>{{ $t("Date From") }}</label>
                  <b-form-input
                    v-model="filter.receiving_date_from"
                    type="date"
                  ></b-form-input>
                </div>
              </div>

              <div class="col-xl-2 col-sm-6 pt-0">
                <div class="form-group mb-0">
                  <label>{{ $t("Date To") }}</label>
                  <b-form-input
                    v-model="filter.receiving_date_to"
                    type="date"
                  ></b-form-input>
                </div>
              </div>

              <div class="col-xl-2 col-sm-6 pt-0">
                <div class="form-group mb-0">
                  <label>{{ $t("Status") }}</label>
                  <select
                    class="form-control select2-search-disable"
                    v-model="filter.status"
                  >
                    <option
                      v-for="{ name, value } in orderStatuses"
                      :key="value"
                      :value="value"
                    >
                      {{ $t(name) }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="col-xl-3 col-sm-6 pt-0">
                <label>{{ $t("Search") }}</label>
                <div class="d-flex align-center mb-0">
                  <select
                    class="form-control select2-search-disable"
                    style="width: 100px"
                    v-model="orderSearch.searchBy"
                  >
                    <option :value="null" disabled>Search By</option>
                    <option value="reference_number">
                      {{ $t("Reference ID") }}
                    </option>
                    <option value="order_number">{{ $t("Order ID") }}</option>
                  </select>
                  <b-form-input
                    v-model="orderSearch.searchId"
                    type="text"
                  ></b-form-input>
                </div>
              </div>
              <div class="col-xl-3 col-sm-6 align-self-end pb-3">
                <div class="mt-0 d-flex justify-end align-center">
                  <div :class="isRtl ? 'ml-auto' : 'mr-auto'">
                    <v-btn color="primary_1" dark @click="applyFilter">
                      <i class="fa fa-search"></i>
                    </v-btn>
                    <v-btn
                      class="mx-2"
                      color="warning"
                      dark
                      @click="resetFilter"
                    >
                      <i class="fa fa-trash"></i>
                    </v-btn>
                  </div>
                </div>
              </div>
              <div
                class="col-xl-12 mt-4 col-sm-6 pt-0 d-flex justify-content-xl-end justify-content-start align-items-end"
              >
                <v-menu offset-y>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      :class="isRtl ? 'ml-3' : 'mr-3'"
                      outlined
                      @click="openImportModal = true"
                    >
                      {{ $t("Import") }}
                    </v-btn>
                    <v-btn
                      color="primary"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      outlined
                    >
                      {{ $t("Export") }}
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item @click.prevent="exportSheet('pdf')">
                      <v-list-item-title>
                        <i class="fa fa-file-pdf mr-2"></i>
                        Pdf</v-list-item-title
                      >
                    </v-list-item>
                    <v-list-item @click.prevent="exportSheet('xlsx')">
                      <v-list-item-title
                        ><i class="fa fa-file-excel mr-2"></i
                        >Excel</v-list-item-title
                      >
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </div>
            <SkeletonLoader type="table" v-if="showContentLoader" />
            <div v-else>
              <WsTable
                :items="items"
                :totalItems="totalItems"
                :fields="fields"
                :showPage="'order-details'"
                :handleChangeDeliverySpeed="handleChangeDeliverySpeed"
                :paginateStart="paginateStart"
                :onRowClicked="onRowClicked"
                :downloadFile="downloadFile"
                clickable
                style="cursor: pointer"
              />
              <div class="row">
                <div class="col">
                  <div
                    class="dataTables_paginate paging_simple_numbers float-end"
                  >
                    <ul class="pagination pagination-rounded mb-0">
                      <!-- pagination -->
                      <b-pagination
                        v-model="currentPage"
                        :total-rows="totalItems"
                        :per-page="perPage"
                        :first-text="this.$t('First')"
                        :prev-text="this.$t('Prev')"
                        :next-text="this.$t('Next')"
                        :last-text="this.$t('Last')"
                      ></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        :dialog="openImportModal"
        :closeModal="closeModal"
        :uploadSuccess="uploadSuccess"
        :modalTitle="modalTitle"
        :modalNote="modalNote"
        :errors="errors"
      >
        <template>
          <div class="text-center my-5 d-flex">
            <a
              v-if="services.international"
              class="text-info border border-info p-2 rounded-2 fw-bold mr-3 flex-grow-1"
              @click="downloadTemplate"
            >
              {{ $t("International orders template") }}
              <v-icon :class="isRtl ? 'mr-2' : 'ml-2'" size="20"
                >$vuetify.icons.download</v-icon
              >
            </a>
            <a
              v-if="services.domestic"
              class="text-info border border-info p-2 rounded-2 fw-bold flex-grow-1"
              @click="downloadTemplate"
            >
              {{ $t("Domestic orders template") }}
              <v-icon :class="isRtl ? 'mr-2' : 'ml-2'" size="20"
                >$vuetify.icons.download</v-icon
              >
            </a>
             <a
              v-if="services.storage"
              class="text-info border border-info p-2 rounded-2 fw-bold flex-grow-1"
              @click="downloadTemplate"
            >
              {{ $t("Download template") }}
              <v-icon :class="isRtl ? 'mr-2' : 'ml-2'" size="20"
                >$vuetify.icons.download</v-icon
              >
            </a>
          </div>
        </template>
      </Modal>
    </div>
  </Layout>
</template>
<style lang="scss" scoped>
.p-item + .p-item:before {
  content: ", ";
}
.toggle-box {
  background-color: gray;
  width: 75%;
  margin: 0 auto;
  border-radius: 10px;
  padding: 1px;
  cursor: pointer;
  position: relative;
  &__ball {
    height: 1.5rem;
    width: 1.5rem;
    border-radius: 50%;
    background-color: var(--v-shadow-base);
    &--default {
      background-color: var(--v-shadow-base);
      margin-left: 0;
    }
    &--active {
      background-color: var(--v-success-base);
      margin-left: auto;
    }
  }
  &__text {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translate(-50%, 0);
  }
}
</style>
